import React, { useState, useEffect } from "react";
import {
  CardTitle,
  CardBody,
} from "reactstrap";
import moment from 'moment';
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//service
import leadCollectorService from "../../../../utils/services/leadCollector";
import * as groupService from "../../../../utils/services/group";
import StandModel from '../../../../utils/models/StandModel';

import CommandButtons from './CommandButtons';
import EventLink from "./EventLink";
import ModalAddGroups from './ModalAddGroups';
import ModalInactiveGroup from './ModalInactiveGroup';
import StandsList from './StandsList';

function LeadCollectorStands(props) {
  const location = useLocation();
  const eventId = location.state.idEvent;
  const foundProducts = props.state.global_user_data.data.foundProducts;

  const isLoadingRef = React.useRef(false);
  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [standsList, setStandsList] = useState([]);
  // loading
  const [loading, setLoading] = useState(false);
  const [searchControl, setSearchControl] = React.useState({
    search: '',
    total: 0,
    orderBy: 'organization_name',
    order: 'ASC'
  });
  const searchControlRef = React.useRef(searchControl);
  React.useEffect(() => {
    searchControlRef.current = searchControl;
  }, [searchControl]);
  const lastSearchStringUpdate = React.useRef(Date.now());
  const [currentIndex, setCurrentIndex] = useState(1);
  const currentIndexRef = React.useRef(currentIndex);
  React.useEffect(() => {
    currentIndexRef.current = currentIndex;
    getData();
  }, [currentIndex]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageRef = React.useRef(itemsPerPage);
  React.useEffect(() => {
    itemsPerPageRef.current = itemsPerPage;
    getData();
  }, [itemsPerPage]);
  const [groups, setGroups] = useState([]);
  const [modalAddGroupsControl, setModalAddGroupsControl] = React.useState({
    open: false,
    groups: [],
  });
  const [modalInactiveGroupControl, setModalInactiveGroupControl] = React.useState({
    open: false,
    groupId: '',
    groupName: '',
  });

  useEffect(() => {
    getData();
    getGroupsFunc();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      if (isLoadingRef.current) {
        return;
      }
      isLoadingRef.current = true;
      setLoading(true);
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      let _offset = (currentIndexRef.current - 1) * itemsPerPageRef.current;

      let _stands = await leadCollectorService.getStands(
        eventId,
        searchControlRef.current.search,
        itemsPerPageRef.current,
        _offset,
        searchControlRef.current.orderBy,
        searchControlRef.current.order,
      );

      setStandsList(_stands.data);
      setSearchControl({ ...searchControlRef.current, total: _stands.count });

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      isLoadingRef.current = false;
      setLoading(false);
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [searchControl, itemsPerPage, currentIndex, standsList]);

  const getGroupsFunc = React.useCallback(async () => {
    try {
      let _groups = await groupService.getGroups({
        jwt: props.state.global_user_data.data.token,
        eventId: eventId,
        offset: 1,
        limit: 0,
        search: "",
      });
      setGroups(_groups.findOneGroupData.data);
    } catch (error) {
      console.log('Error getGroupsFunc', error);
    }
  }, [groups]);

  const trySaveGroups = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Salvando' });

      let _isAddAll = modalAddGroupsControl.groups.find(g => { return g.value === 'todos' });
      if (_isAddAll) {
        await trySaveAll();
      } else {
        await trySaveSelected();
      }

      setModalAddGroupsControl({
        open: false,
        groups: [],
      });

      setAlertControl({
        ...alertControl,
        open: true,
        title: 'Salvo',
        message: 'Stand(s) salvo(s) com sucesso',
        status: 'success'
      });

      getData();

    } catch (error) {
      console.log('Error trySaveGroups', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    async function trySaveAll() {
      if (groups.length <= 0) { return; }

      let _count = 0;
      do {
        setLoadingControl({ ...loadingControl, open: true, message: `Salvando ${_count + 1} de ${groups.length}` });

        let _group = groups[_count];
        await leadCollectorService.saveStand(
          eventId,
          _group.name,
        );
        _count++;
      } while (_count < groups.length);

      return;
    }

    async function trySaveSelected() {
      if (groups.length <= 0) { return; }

      let _count = 0;
      do {
        setLoadingControl({ ...loadingControl, open: true, message: `Salvando ${_count + 1} de ${modalAddGroupsControl.groups.length}` });

        let _group = modalAddGroupsControl.groups[_count];
        await leadCollectorService.saveStand(
          eventId,
          _group.label,
        );
        _count++;
      } while (_count < modalAddGroupsControl.groups.length);

      return;
    }
  }, [groups, modalAddGroupsControl]);

  const openModalInactiveGroup = React.useCallback((stand = StandModel()) => {
    let _group = groups.find(g => {
      return stand.organizationName.toUpperCase() === g.name.toUpperCase();
    });
    setModalInactiveGroupControl({
      open: true,
      groupId: _group.id,
      groupName: _group.name,
    });
  }, [groups, modalInactiveGroupControl]);

  const tryDeleteGroup = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Salvando' });

      setModalInactiveGroupControl({
        ...modalInactiveGroupControl,
        open: false,
      });

      await leadCollectorService.inactiveStand(
        eventId,
        modalInactiveGroupControl.groupName,
      );

      setAlertControl({
        ...alertControl,
        open: true,
        title: 'Salvo',
        message: 'Stand deletado com sucesso',
        status: 'success'
      });

      getData();

    } catch (error) {
      console.log('Error tryDeleteGroup', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [groups, modalInactiveGroupControl]);

  return (
    <div>
      <CardTitle>Stands</CardTitle>
      <EventLink eventId={eventId} />
      <CommandButtons
        searchControl={searchControl}
        setSearchControl={setSearchControl}
        lastSearchStringUpdate={lastSearchStringUpdate}
        getData={getData}
        modalAddGroupsControl={modalAddGroupsControl}
        setModalAddGroupsControl={setModalAddGroupsControl}
      />
      <StandsList
        standsList={standsList}
        openModalInactiveGroup={openModalInactiveGroup}
        loading={loading}
      />
      <Pagination
        data={standsList}
        search={searchControl.search}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={searchControl.total}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />

      <ModalAddGroups
        modalAddGroupsControl={modalAddGroupsControl}
        setModalAddGroupsControl={setModalAddGroupsControl}
        groups={groups}
        trySaveGroups={trySaveGroups}
      />
      <ModalInactiveGroup
        modalInactiveGroupControl={modalInactiveGroupControl}
        setModalInactiveGroupControl={setModalInactiveGroupControl}
        tryDeleteGroup={tryDeleteGroup}
      />
      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(LeadCollectorStands);
